
import TopMenuBar from '../components/TopMenuBar.vue';

export default {
  name: 'MainLayout',
  props: {
    headTitle: String,
    showMenu: Boolean,
    showBackButton: Boolean,
    backRouteName: String,
    showRightMenu: Boolean,
    showFooterMenu: Boolean,
    mainContainerClass: { type: String, default: 'uk-container-xsmall' },
  },
  components: { TopMenuBar },
};
